import * as React from 'react'
import * as PropTypes from 'prop-types'
import { Rule } from 'glamor'

import { useTheme } from '../../theme'

import { Flex } from '../flex'

type BackdropFillMode = 'window' | 'offsetParent'

const fillModes: BackdropFillMode[] = ['window', 'offsetParent']

interface IBackdropProps {
  children?: React.ReactNode
  style?: Rule
  fillMode?: BackdropFillMode
}

export function Backdrop({ children, style, fillMode, ...rest }: IBackdropProps) {
  const theme = useTheme()
  return (
    <Flex
      {...rest}
      style={{
        position: fillMode === 'offsetParent' ? 'absolute' : 'fixed',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        zIndex: 5,
        backgroundColor: theme.colors.backgrounds.overlayLight,
        ...style,
      }}
    >
      {children}
    </Flex>
  )
}

Backdrop.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
  fillMode: PropTypes.oneOf(fillModes),
}

Backdrop.defaultProps = {
  fillMode: 'window',
}

Backdrop.FILL_MODES = fillModes
